import React, { ChangeEvent, MouseEvent } from "react";
import { Link } from "react-router-dom";

import { V2 } from "../../Api";
import withTitle from "../withTitle";
import ViewToolbar from "../ViewToolbar";
import ToolbarMenuItem from "../ToolbarMenuItem";

interface ISurveyAdminViewState {
    isLoading: boolean | string;
    isSavingQuestions: boolean | string;
    hasChangedQuestions: boolean;

    questionEditIndex?: number;
    questionEditValue: string;
    questionEditGroup: string;
    questionNewValue: string;
    questionNewGroup: string;

    surveys: any[];

    questions: any[];

    [name: string]: any;
}

class SurveyAdminView extends React.Component<{}, ISurveyAdminViewState> {
    constructor(props: Readonly<{}>) {
        super(props);

        const state: ISurveyAdminViewState = {
            isLoading: true,
            isSavingQuestions: false,

            questionEditValue: "",
            questionEditGroup: "",
            questionNewValue: "",
            questionNewGroup: "",
            hasChangedQuestions: false,

            surveys: [],

            questions: [],
        };

        this.state = state;

        this.editQuestion = this.editQuestion.bind(this);
        this.saveQuestion = this.saveQuestion.bind(this);
        this.addQuestion = this.addQuestion.bind(this);
        this.questionInputChanged = this.questionInputChanged.bind(this);
        this.saveAllQuestions = this.saveAllQuestions.bind(this);
        this.deleteQuestion = this.deleteQuestion.bind(this);
    }

    public async componentDidMount() {
        try {
            const [surveys, questions] = await Promise.all([
                V2.get<any[]>("survey-types"),
                V2.get<any[]>("survey-types/questions"),
            ]);

            this.setState({
                isLoading: false,

                questions,
                surveys,
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || e || "Could not load surveys"
            });
        }
    }

    public render() {
        return (
            <div className="viewer-root">
                <ViewToolbar>
                    <ToolbarMenuItem>
                        <Link to="/survey/admin/new" className="icon-plus" />
                    </ToolbarMenuItem>
                </ViewToolbar>
                <h3>Survey types</h3>
                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th className="col-smallest">Questions</th>
                            <th className="col-smallest" />
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.isLoading === true
                                ? <tr><td colSpan={10}><span className="spinner spinner-center lds-dual-ring" /></td></tr>
                                : typeof this.state.isLoading === "string"
                                    ? <tr><td colSpan={10}><span className="error-text">{this.state.isLoading}</span></td></tr>
                                    : this.state.surveys.length === 0
                                        ? <tr><td colSpan={10}>No surveys found</td></tr>
                                        : this.state.surveys.map(a => <tr key={a.id}>
                                            <td>{a.title}</td>
                                            <td>{a.questionCount}</td>
                                            <td><Link to={`/survey/admin/${a.id}`} className="button small">Edit</Link></td>
                                        </tr>)
                        }
                    </tbody>
                </table>

                <h3>Question Pool</h3>
                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th className="col-smallest">Indicator</th>
                            <th className="col-smallest">Type</th>
                            <th className="col-smallest" />
                            <th className="col-smallest" />
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.isLoading === true
                                ? <tr><td colSpan={10}><span className="spinner spinner-center lds-dual-ring" /></td></tr>
                                : typeof this.state.isLoading === "string"
                                    ? <tr><td colSpan={10}><span className="error-text">{this.state.isLoading}</span></td></tr>
                                    : this.state.surveys.length === 0
                                        ? <tr><td colSpan={10}>No questions found</td></tr>
                                        : this.state.questions.map((a, i) => (
                                            i === this.state.questionEditIndex
                                                ? <tr key={a.id}>
                                                    <td className="col-nopad"><input type="text" name="questionEditValue" value={this.state.questionEditValue} onChange={this.questionInputChanged} autoFocus={true} /></td>
                                                    <td className="col-nopad">{this.renderIndicatorDropdown("questionEditGroup")}</td>
                                                    <td>{this.questionTypeToString(a.type)}</td>
                                                    <td className="col-nopad"><button type="button" className="button btn-light small" onClick={e => this.saveQuestion(i)}><i className="icon-check" /></button></td>
                                                    <td className="col-nopad"><button type="button" className="button btn-light small red" onClick={e => this.deleteQuestion(i)}><i className="icon-trash" /></button></td>
                                                </tr>
                                                : <tr key={a.id}>
                                                    <td>{a.text}</td>
                                                    <td>{a.group}</td>
                                                    <td>{this.questionTypeToString(a.type)}</td>
                                                    <td className="col-nopad"><button type="button" className="button btn-light small" onClick={e => this.editQuestion(i)} disabled={this.state.questionEditIndex !== undefined}><i className="icon-pencil" /></button></td>
                                                    <td className="col-nopad"><button type="button" className="button btn-light small red" onClick={e => this.deleteQuestion(i)}><i className="icon-trash" /></button></td>
                                                </tr>
                                        ))
                        }
                        <tr>
                            <td className="col-nopad"><input type="text" name="questionNewValue" value={this.state.questionNewValue} onChange={this.questionInputChanged} autoFocus={true} /></td>
                            <td className="col-nopad">{this.renderIndicatorDropdown("questionNewGroup")}</td>
                            <td>Yes/No</td>
                            <td colSpan={2} className="col-nopad"><button type="button" className="button btn-light small" onClick={this.addQuestion}><i className="icon-plus" /></button></td>
                        </tr>
                    </tbody>
                </table>
                &nbsp;
                {this.state.isSavingQuestions === true
                    ? <span className="spinner spinner-center lds-dual-ring" />
                    : typeof this.state.isSavingQuestions === "string"
                        ? <span className="error-text">{this.state.isSavingQuestions}</span>
                        : null}
                {this.state.hasChangedQuestions
                    ? <div className="action-bar-dialog">
                        <button type="button" className="button push-right" onClick={this.saveAllQuestions}>Save Questions</button>
                    </div>
                    : null
                }
            </div>
        );
    }

    private questionTypeToString(type: string) {
        switch (type) {
            case "yesno": return "Yes/No"
            default: return type;
        }
    }

    private editQuestion(index: number) {
        if (this.state.questionEditIndex !== undefined) {
            return
        }

        const questionText = this.state.questions[index].text;
        const questionGroup = this.state.questions[index].group;

        this.setState({
            questionEditIndex: index,
            questionEditValue: questionText,
            questionEditGroup: questionGroup
        });
    }

    private saveQuestion(index: number) {
        const questions = this.state.questions;
        questions[index].text = this.state.questionEditValue;
        questions[index].group = this.state.questionEditGroup;
        // questions[index].id = this.createQuestionId(questions[index].text);

        this.setState({
            questionEditIndex: undefined,
            questions,

            hasChangedQuestions: true
        });
    }

    private deleteQuestion(index: number) {
        const questions = this.state.questions;

        questions.splice(index, 1);

        this.setState({
            questions,

            hasChangedQuestions: true
        });
    }

    private addQuestion(e: MouseEvent<HTMLButtonElement>) {
        const questions = this.state.questions;
        questions.push({
            id: this.createQuestionId(this.state.questionNewValue),
            text: this.state.questionNewValue,
            type: "yesno"
        });

        this.setState({
            questionEditIndex: undefined,
            questionNewValue: "",
            questions,

            hasChangedQuestions: true
        });
    }

    private questionInputChanged(e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) {
        const name = e.currentTarget.name;
        const value = e.currentTarget.value;

        this.setState({
            [name]: value
        });
    }

    private async saveAllQuestions() {
        try {
            this.setState({
                isSavingQuestions: true
            });

            await V2.put("survey-types/questions", this.state.questions);

            this.setState({
                isSavingQuestions: false,
                hasChangedQuestions: false
            });
        }
        catch (e) {
            this.setState({
                isSavingQuestions: e.message || e || "Could not save questions"
            });
        }
    }

    private createQuestionId(text: string) {
        const trimwords = "do you a or of to is can are have when you're doing".split(" ");
        const textParts = text.toLowerCase().split(" ").map(a => a.replace(/\W/g, "")).filter(a => trimwords.indexOf(a) === -1);

        return textParts.join("_");
    }

    private renderIndicatorDropdown(name: string) {
        return <select name={name} value={this.state[name]} onChange={this.questionInputChanged}>
            <option value="">None</option>
            <option value="surgery">Surgery</option>
            <option value="hormone">Hormone</option>
            <option value="late_annual">Past Due Annual</option>
            <option value="existing_patient">Existing Patient</option>
        </select>;
    }
}

export default withTitle("Survey Admin", SurveyAdminView);
